/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询入选人名单
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class FindApplyActivityFinalistParams {
  constructor(public page: number, public size: number) {}
}

export default async function (
  activityId: string,

  params: FindApplyActivityFinalistParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.Page<cms.ApplyActivityMemberDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/apply-activity/finalist/${activityId}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
